export const VENDOR_LIST = "ESPORT_VENDOR_LIST";
export const ESPORT_GAME_ACCESS = "ESPORT_GAME_ACCESS";
